import type { Module } from 'vuex';
import { setAxiosSessionCredentials } from '@/api/axiosSessionAuth';
import { refreshCurrentUser } from '@/api/user';
import type { RootState } from '@/store/rootState';
import type {
    UserSessionApiPayload,
    UserSessionAuthenticated,
    UserSessionInStore,
    UserState,
} from '@/types/user';
import {
    isUserSessionApiDenied,
    isUserSessionAuthenticated,
} from '@/types/user';

function clearSession(commit: (type: string) => void): void {
    commit('removeUserData');
    localStorage.removeItem('userData');
    setAxiosSessionCredentials(null, null);
}

export const userModule: Module<UserState, RootState> = {
    state: (): UserState => ({
        data: null,
    }),
    getters: {
        userData(state): UserSessionInStore {
            return state.data;
        },
    },
    mutations: {
        setUserData(state, data: UserSessionInStore) {
            state.data = data;
        },
        removeUserData(state) {
            state.data = null;
        },
    },
    actions: {
        async updateUserDataServer({ commit }: { commit: (type: string, payload?: unknown) => void }) {
            try {
                const data: UserSessionApiPayload = await refreshCurrentUser();
                if (isUserSessionApiDenied(data)) {
                    clearSession(commit);
                    window.location.href = '/';
                    return;
                }
                if (!isUserSessionAuthenticated(data)) {
                    clearSession(commit);
                    window.location.href = '/';
                    return;
                }
                commit('setUserData', data);
                localStorage.setItem('userData', JSON.stringify(data));
            } catch {
                clearSession(commit);
                window.location.href = '/';
            }
        },
    },
    namespaced: true,
};
